import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent } from 'vue';
import { ScrollUpButton } from '@/shared/ui';
import { AppFooter } from '@/widgets/Footer';
import { AppHeader } from '@/widgets/Header';
export default defineComponent({
  name: 'UnauthorizedLayout',
  components: {
    AppFooter: AppFooter,
    ScrollUpButton: ScrollUpButton,
    AppHeader: AppHeader
  },
  props: {
    withLoginButton: {
      type: Boolean,
      default: true
    },
    withBackLink: {
      type: Boolean,
      default: false
    },
    hasFooter: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup() {
    return {};
  },
  computed: {
    isFixed: function isFixed() {
      var _this$$route, _this$$route2;
      return ((_this$$route = this.$route) === null || _this$$route === void 0 || (_this$$route = _this$$route.name) === null || _this$$route === void 0 ? void 0 : _this$$route.includes('contract')) || ((_this$$route2 = this.$route) === null || _this$$route2 === void 0 || (_this$$route2 = _this$$route2.name) === null || _this$$route2 === void 0 ? void 0 : _this$$route2.includes('account'));
    }
  }
});